import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { login, postUsuario } from "../../Redux/Reducers/Usuario";
import "./Login.css";
import Swal from "sweetalert2";

const Login = () => {
  const dispatch = useDispatch();
  const [inicio, registro] = useState(false);
  const [loginTo, setLoginTo] = useState({ name: "", password: "" });
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });
  console.log(inicio);
  const changeForm = (e) => {
    e.preventDefault();
    if (!inicio) {
      registro(true);
      document.getElementById("name").value = "";
      document.getElementById("email").value = "";
      document.getElementById("password").value = "";
    } else {
      registro(false);
      document.getElementById("name").value = "";
      document.getElementById("password").value = "";
    }
  };
  const handleOnChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleOnChangeLogin = (e) => {
    setLoginTo({ ...loginTo, [e.target.name]: e.target.value });
  };
  const ButtonRegister = (e) => {
    e.preventDefault();
    dispatch(postUsuario(form)).then(() => {
      Swal.fire({
        title: "¡Éxito!",
        text: "Cuenta creada con exito.",
        icon: "success",
        confirmButtonText: "Aceptar",
      });
    });
    document.getElementById("name").value = "";
    document.getElementById("email").value = "";
    document.getElementById("password").value = "";
    registro(true);
  };
  const ButtonLogin = (e) => {
    e.preventDefault();
    dispatch(login(loginTo)).then(() => {
      if (localStorage.getItem("userCredentials") !== null) {
        // La propiedad existe en el localStorage
        Swal.fire({
          title: "¡Éxito!",
          text: "Inicio de sesion exitoso.",
          icon: "success",
          confirmButtonText: "Aceptar",
          willClose: () => {
            window.location.reload();
          },
        });
      } else {
        // La propiedad no existe en el localStorage
        Swal.fire({
          title: "¡Error!",
          text: "Nombre de usuario o contraseña.",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      }
    });
  };
  console.log(form);
  console.log(loginTo);
  return (
    <>
      <div className="contact-container">
        <div className="contact-content">
          {!inicio ? (
            <>
              <div className="title-contact-form">
                <h1>Registrese!</h1>
                <br />
                <p>
                  Y empiece a saber en que gasta demasiado como para no llegar a
                  fin de mes
                </p>
                <br />
              </div>
              <div className="form">
                <form>
                  <input
                    onChange={handleOnChange}
                    name="name"
                    className="input"
                    placeholder="Nombre de usuario"
                    type={"text"}
                    id="name"
                  />
                  <input
                    onChange={handleOnChange}
                    className="input"
                    name="email"
                    placeholder="Tu email"
                    type={"email"}
                    id="email"
                  />
                  <input
                    onChange={handleOnChange}
                    className="input"
                    name="password"
                    placeholder="Contraseña de mas de 6 caracteres"
                    type={"text"}
                    id="password"
                  />
                  <div className="div-button">
                    <button
                      className="button-form-contact"
                      type="submit"
                      value={"submit"}
                      disabled={
                        form.name === "" ||
                        form.email === "" ||
                        form.password === "" ||
                        form.password.length < 6
                      }
                      onClick={ButtonRegister}
                    >
                      Enviar
                    </button>
                  </div>
                  <a href="" onClick={changeForm}>
                    Ya tengo una cuenta
                  </a>
                </form>
              </div>
            </>
          ) : (
            <>
              <div className="title-contact-form">
                <h1>Inicie sesión!</h1>
                <br />
                <p>Y siga viendo como si dinero del mes se va en pocos dias</p>
                <br />
              </div>
              <div className="form">
                <form>
                  <input
                    onChange={handleOnChangeLogin}
                    name="name"
                    className="input"
                    placeholder="Nombre de usuario"
                    type={"text"}
                    id="name"
                  />

                  <input
                    onChange={handleOnChangeLogin}
                    className="input"
                    name="password"
                    placeholder="Contraseña de mas de 6 caracteres"
                    type={"text"}
                    id="password"
                  />
                  <div className="div-button">
                    <button
                      className="button-form-contact"
                      type="submit"
                      value={"submit"}
                      disabled={
                        loginTo.name === "" ||
                        loginTo.password === "" ||
                        loginTo.password.length < 6
                      }
                      onClick={ButtonLogin}
                    >
                      Enviar
                    </button>
                  </div>
                  <a href="" onClick={changeForm}>
                    No poseo una cuenta
                  </a>
                </form>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Login;
